import { render, staticRenderFns } from "./Building.vue?vue&type=template&id=7e447945&scoped=true"
import script from "./Building.vue?vue&type=script&lang=js"
export * from "./Building.vue?vue&type=script&lang=js"
import style0 from "./Building.vue?vue&type=style&index=0&id=7e447945&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e447945",
  null
  
)

export default component.exports